import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import type { Source } from "@onetasklist/shared";
import { HARDCODED_PLANNED_SOURCE_DEFINITIONS } from "@onetasklist/shared";

/**
 * Returns the hardcoded planned (backlog) sources with descriptions resolved
 * through the active i18n locale. These are merged with the API sources in
 * the ConnectionsLevel ViewModel – any source whose id already exists in the
 * API response is automatically excluded, so graduating a planned source to
 * live requires no changes here.
 */
export const useCataloguePlannedSources = (): readonly Source[] => {
  const { t } = useTranslation();

  return useMemo(
    () =>
      HARDCODED_PLANNED_SOURCE_DEFINITIONS.map((def) => {
        const prefix = `board.connections.sources.${def.id}`;
        const displayName = t(`${prefix}.displayName`, def.displayName);
        const description = t(def.descriptionKey, def.displayName);
        return {
          id: def.id,
          displayName,
          description,
          category: def.category,
          backlog: true as const,
          order: def.order,
          goToSettingsOnCreate: false,
          supportsPush: false,
          alpha: false,
        };
      }),
    [t],
  );
};
